// extracted by mini-css-extract-plugin
export default {"elo":"Elo_elo__Ws+sc"};